import SectionHeader from "../../components/SectionHeader";
import { GridInputs } from "../../../../../../components/Functional";
import useUser from "../../../../../../hooks/useUser";

const Terms = props => {
  const { formik } = props;
  const { hasPermission } = useUser();

  const inputs = {
    className: "grid grid-cols-1 gap-4 lg:grid-cols-4 lg:gap-8",
    inputs: [
      {
        className: "grid-cols-1 gap-4 lg:col-span-4",
        inputs: [
          {
            label: "",
            name: "termsback",
            rows: 40,
            type: "textarea",
            submitOnBlur: true,
            readOnly: true,
            disabled: !hasPermission("UPDATE_INVOICE"),
          },
        ],
      },
    ],
  };

  const detailInputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="w-full">
      <SectionHeader title="Terms" />
      <div className="px-4 sm:px-6 lg:px-8 pb-8">
        <GridInputs {...detailInputProps} />
      </div>
    </div>
  );
};

export default Terms;
